
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region/facility/natural",
      function () {
        return require("private-next-pages/region/facility/natural/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/region/facility/natural"])
      });
    }
  